import { Typography } from '@mui/material'
import { FloatingMenuPopover } from '@/components/FloatingMenuPopup/FloatingMenuPopover'
import floatingMenuStyles from '@/components/FloatingMenuPopup/index.module.scss'
import { MENU_WIDTH } from './AiAskBarHomeRightAgentSelect.constants'
import { agentSelectMenuPaperClass } from './agentSelectMenuPaperClass'
import ProviderEntries from './AiAskBarHomeRightAgentSelectProviderEntries'

export default function AiAskBarHomeRightAgentSelectProviderMenu(props) {
  const { open, anchorEl, onClose, listRef } = props
  return (
    <FloatingMenuPopover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      hideBackdrop
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      paperClassName={agentSelectMenuPaperClass}
      paperSx={{ width: MENU_WIDTH, minWidth: MENU_WIDTH }}
      listRef={listRef}
      menuListAriaLabel="Select Model"
      header={
        <Typography component="span" variant="body2" className={floatingMenuStyles.menuTitle}>
          AI Models
        </Typography>
      }
      entries={<ProviderEntries {...props} />}
    />
  )
}
